import { isServerSideRender } from "@nf/helpers";

import { useState, useEffect } from "react";

export const useScrolled = (threshold = 10) => {
  const [scrolled, setScrolled] = useState(() => {
    // Initialize on first render
    if (isServerSideRender) {
      return false;
    }

    return window.scrollY > threshold;
  });

  useEffect(() => {
    const toggleScroll = () => setScrolled(window.scrollY > threshold);

    window.addEventListener("scroll", toggleScroll, { passive: true });
    return () => window.removeEventListener("scroll", toggleScroll);
  }, [threshold]);

  return scrolled;
};
